<template>
	<BaseCenteredMessage hideHelpButton hideActions>
		<template #icon>
			<img src="../img/bird-nervous.svg" alt="error image" />
		</template>
		<template #title>Error Loading Data</template>
		<template #details>
			<p class="mb-20 mt-32">
				<span v-if="$auth.isAuthenticated.value">
					Please try to logout and re-login again to see if this fixes the issue.
					<br />
					If not, reach out to us via
				</span>
				<span v-else>Please reach out to us via</span>
				<a href="mailto:support@birdeatsbug.com?subject=App failed to load user data" class="link-blue">
					Email
				</a>
				or
				<a
					href="https://join.slack.com/t/birdeatsbugcommunity/shared_invite/enQtODIyMzMzNzI1MTY5LTE3OTY1OTgxYTcyNzRkMGQxMmRkYjJlN2Q1ZmFkZmQ1OTgyNGUzNDEwODI0YjBmMmVlZWVmNzczMWFiNTMwMWI"
					class="link-blue"
					target="_blank"
					rel="noreferrer"
				>
					Slack
				</a>
				. Together we can resolve this!
			</p>
			<p>
				You can check how {{ $store.productName }}'s systems are running
				<br />
				on
				<a href="https://status.birdeatsbug.com" class="link-blue" target="_blank" rel="noreferrer">
					https://status.birdeatsbug.com
				</a>
				.
			</p>
		</template>
	</BaseCenteredMessage>
</template>
